module.exports = __webpack_public_path__ + "img/before_right_img.00db1f8e.png";